import React, { useState, useEffect, useRef } from "react";
import { Modal, Card, Col, Button } from "react-bootstrap";
import { withNamespaces } from "react-i18next";
import Document from "./Document";

const GeneralDocument = ({
  t,
  experiencedUser,
  show,
  datacaptureConfiguration,
  handleCloseUploadModal,
  docTypeSelected,
}) => {
  const [showChooseDocType, setShowChooseDocType] = useState(null);
  const [docType, setDocType] = useState(null);

  useEffect(() => {
    if (datacaptureConfiguration.length > 0) {
      if (datacaptureConfiguration.length === 1) {
        const docType_ = datacaptureConfiguration[0].documentType;
        if (docType_) {
          setDocType(docType_);
          setShowChooseDocType(false);
        }
      } else setShowChooseDocType(true);
    } else {
      setShowChooseDocType(false);
      setDocType(docTypeSelected);
    }
  }, [datacaptureConfiguration]);

  const handleClick = (type) => {
    setDocType(type);
    setShowChooseDocType(false);
  };

  const renderOptions = (className) => {
    const buttons = [];

    datacaptureConfiguration = datacaptureConfiguration.filter(
      (e) => docTypeSelected === e.documentType
    );

    if (datacaptureConfiguration && datacaptureConfiguration.length > 0) {
      datacaptureConfiguration.forEach((conf, index) => {
        !conf.deprecated &&
          buttons.push(
            <Button
              key={index}
              className={className}
              style={{
                marginRight: "10px",
                marginLeft: "10px",
                whiteSpace: "nowrap",
              }}
              onClick={() =>
                handleClick(conf.documentType ? conf.documentType : "")
              }
            >
              {conf.label ? conf.label.toUpperCase() : ""}
            </Button>
          );
      });
    }
    return buttons;
  };
  const isMobile = window.innerWidth < 992 ? true : false;

  const renderModal = () => {
    return (
      <Modal
        show={showChooseDocType}
        dialogClassName="modal-50w"
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title>
            {t("datacapture.automated.selectDocumentType")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body
          style={{ padding: "20px", display: "flex", flexWrap: "nowrap" }}
        >
          {renderOptions("modal-submit-button")}
        </Modal.Body>
      </Modal>
    );
  };

  const renderCard = () => {
    return (
      <div className="main-card-v2" style={{ padding: "0" }}>
        <Card bsPrefix="card-flat">
          <Card.Header
            className="justify-content-between"
            style={{
              padding: "16px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h4 style={isMobile ? { fontSize: "18px" } : { margin: "0" }}>
              {t("datacapture.automated.selectDocumentType")}
            </h4>
          </Card.Header>
          <Card.Body style={{ display: "flex", flexDirection: "column" }}>
            <Col
              style={
                isMobile ? { display: "flex", justifyContent: "center" } : {}
              }
            >
              {renderOptions("card-button")}
            </Col>
          </Card.Body>
        </Card>
      </div>
    );
  };

  return experiencedUser ? (
    showChooseDocType && show ? (
      renderCard()
    ) : (
      <Document
        docType={docType}
        experiencedUser={experiencedUser}
        show={show}
        datacaptureConfiguration={datacaptureConfiguration}
        handleCloseUploadModal={handleCloseUploadModal}
      />
    )
  ) : (
    <>
      {renderModal()}
      {docType && (
        <Document
          docType={docType}
          experiencedUser={experiencedUser}
          show={show}
          datacaptureConfiguration={datacaptureConfiguration}
        />
      )}
    </>
  );
};

export default withNamespaces()(GeneralDocument);
